import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsExternalUser } from '~/hooks/useIsExternalUser';
import type { LabelListItem } from '~settings/api/lib/schemas';
import { GroupInfo } from '~settings/components/GroupInfo';
import { LabelName } from '~settings/modules/label/components/LabelName';

export const useSublabelsColumns = () => {
  const isExternal = useIsExternalUser();
  const { t } = useTranslation('settings');

  return useMemo(() => {
    const columnHelper = createColumnHelper<LabelListItem>();

    const sublabelsColumns = {
      name: columnHelper.accessor('name', {
        id: 'name',
        header: () => t('label.title'),
        cell: (cell) => <LabelName name={cell.getValue()} />,
        enableSorting: true,
      }),
      labelGroup: columnHelper.accessor((row) => row.labelGroups, {
        id: 'labelGroups',
        header: () => t('labelGroup.list'),
        cell: (cell) => (
          <GroupInfo groups={(cell.getValue() ?? []).map(({ name }) => name)} />
        ),
        enableSorting: false,
      }),
      usersCount: columnHelper.accessor('usersCount', {
        id: 'usersCount',
        header: () => t('users'),
        cell: (cell) => (cell.getValue() ? cell.getValue() : '-'),
        enableSorting: true,
      }),
    };

    const columnsOrder: (keyof typeof sublabelsColumns)[] = isExternal
      ? ['name', 'usersCount']
      : ['name', 'labelGroup', 'usersCount'];

    return columnsOrder.map((key) => sublabelsColumns[key]);
  }, [t, isExternal]);
};
